var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"},on:{"enter":_vm.enter}},[(_vm.localShow)?_c('div',{class:_vm.type},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }